import { resetPasswordWithTokenDialogReducerKey } from './ResetPasswordWithTokenDialogConstants';

export const resetPasswordWithTokenDialog = (state) => state.get(resetPasswordWithTokenDialogReducerKey);

export const responseStatus = (state) => resetPasswordWithTokenDialog(state).get('responseStatus');

export const newPassword = (state) => resetPasswordWithTokenDialog(state).get('newPassword');

export const confirmationPassword = (state) => resetPasswordWithTokenDialog(state).get('confirmationPassword');
